var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.22717 0C5.7765 0 3.78271 2.11809 3.78271 4.72156C3.78271 7.32504 5.7765 9.44312 8.22717 9.44312C10.6778 9.44312 12.6716 7.32504 12.6716 4.72156C12.6716 2.11809 10.6778 0 8.22717 0ZM8.22717 8.27492C6.42064 8.27492 4.95096 6.6809 4.95096 4.7216C4.95096 2.7623 6.42064 1.16824 8.22717 1.16824C10.0337 1.16824 11.5034 2.76227 11.5034 4.72156C11.5034 6.68086 10.0337 8.27492 8.22717 8.27492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.22695 10.5391C3.69059 10.5391 0 14.2296 0 18.766V20.0005H16.4539V18.7661C16.4539 14.2297 12.7633 10.5391 8.22695 10.5391ZM15.2857 18.8323H1.16824V18.766C1.16824 14.8738 4.33477 11.7073 8.22695 11.7073C12.1191 11.7073 15.2857 14.8738 15.2857 18.766V18.8323Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.32b10dc9605011fdf4f63c60e8883357.svg";
export { ForwardRef as ReactComponent };